import { Markdown as MarkdownBase } from '@design/components/markdown';
import { Tracking } from '@terminal/services/tracking';
import { Components, Options } from 'react-markdown';

export interface MarkdownProps {
  message: string;
  onLoad?: (element: HTMLDivElement) => void;
  components?: Partial<Components>;
  remarkPlugins?: Options['remarkPlugins'];
  isDark?: boolean;
}

export const Markdown = ({
  message,
  onLoad,
  components,
  remarkPlugins,
  isDark = true,
}: MarkdownProps) => {
  const logError = (error: unknown) => {
    if (error instanceof Error) {
      Tracking.captureException(error);
    }
  };

  return (
    <MarkdownBase
      message={message}
      onLoad={onLoad}
      components={components}
      remarkPlugins={remarkPlugins}
      onError={logError}
      isDark={isDark}
    />
  );
};
